var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvertCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03962 5.77539C8.03962 7.10169 6.96693 8.17438 5.64062 8.17438L6.00047 7.57464",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03962 5.77539C8.03962 7.10169 6.96693 8.17438 5.64062 8.17438L6.00047 7.57464",
    stroke: "#7C7C7C",
    strokeWidth: 0.51407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18359 3.71931C1.18359 2.39301 2.25629 1.32031 3.58259 1.32031L3.22274 1.92006",
    stroke: "#7C7C7C",
    strokeWidth: 0.51407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04041 2.07428V2.11198C8.04041 2.20794 7.96502 2.28334 7.86906 2.28334H4.78464C4.68868 2.28334 4.61328 2.20794 4.61328 2.11198V2.07428C4.61328 1.47111 4.76408 1.32031 5.3741 1.32031H7.27959C7.88962 1.32031 8.04041 1.47111 8.04041 2.07428Z",
    fill: "#7C7C7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78464 2.62598C4.68868 2.62598 4.61328 2.70137 4.61328 2.79733V3.14005V3.47933C4.61328 4.08251 4.76408 4.2333 5.3741 4.2333H7.27959C7.88962 4.2333 8.04041 4.08251 8.04041 3.47933V3.14005V2.79733C8.04041 2.70137 7.96502 2.62598 7.86906 2.62598H4.78464Z",
    fill: "#7C7C7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61073 6.01569V6.05339C4.61073 6.14935 4.53533 6.22474 4.43937 6.22474H1.35495C1.25899 6.22474 1.18359 6.14935 1.18359 6.05339V6.01569C1.18359 5.41251 1.33439 5.26172 1.94442 5.26172H3.8499C4.45993 5.26172 4.61073 5.41251 4.61073 6.01569Z",
    fill: "#7C7C7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35495 6.56738C1.25899 6.56738 1.18359 6.64278 1.18359 6.73874V7.08145V7.42074C1.18359 8.02391 1.33439 8.17471 1.94442 8.17471H3.8499C4.45993 8.17471 4.61073 8.02391 4.61073 7.42074V7.08145V6.73874C4.61073 6.64278 4.53533 6.56738 4.43937 6.56738H1.35495Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertCard);
export default __webpack_public_path__ + "static/media/convert-card.4f03994996835dcff1a5e289a8ac99d0.svg";
export { ForwardRef as ReactComponent };